import appInitSaga from './app-init-saga';
import httpErrorSaga from './http-error-saga';
import userSignoutSaga from './user-signout-saga';
import queueDetailSaga from './queue-detail-saga';
import deleteItemSaga from './delete-item-saga';
import saveControlBoxSaga from './save-control-box-saga';
import controlBoxCommandSaga from './control-box-command-saga';
import saveQueueSaga from './save-queue-saga';
import saveBoothSaga from './save-booth-saga';
import saveDisplaySaga from './save-display-saga';
import saveKioskSaga from './save-kiosk-saga';
import saveLocationSaga from './save-location-saga';
import saveServiceSaga from './save-service-saga';
import cbxQueueStatusSaga from './cbx-queue-status-saga';
import assignKioskActionSaga from './assign-kiosk-action-saga';
import kioskCommandSaga from './kiosk-command-saga';
import { messageTrackerSaga } from './message-tracker-saga';
import { providerDeviceStatusSaga } from './provider-device-status-saga';
import { fork } from 'redux-saga/effects';

export function* rootSaga() {
  try {
    yield fork(appInitSaga);
    yield fork(httpErrorSaga);
    yield fork(userSignoutSaga);
    yield fork(queueDetailSaga);
    yield fork(deleteItemSaga);
    yield fork(saveControlBoxSaga);
    yield fork(saveBoothSaga);
    yield fork(saveQueueSaga);
    yield fork(saveLocationSaga);
    yield fork(cbxQueueStatusSaga);
    yield fork(assignKioskActionSaga);
    yield fork(controlBoxCommandSaga);
    yield fork(saveDisplaySaga);
    yield fork(saveKioskSaga);
    yield fork(saveServiceSaga);
    yield fork(kioskCommandSaga);
    yield fork(messageTrackerSaga);
    yield fork(providerDeviceStatusSaga);
  } catch (e) {
    console.warn('Root saga error', e);
  }
}
